export const seamlessPageTransitionFlag = Symbol('seamless-page-transition-flag')
